import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSidebarMenuButton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2836 25.3323C16.5413 25.3323 16.9156 24.806 17.4555 24.806C18.0935 24.806 17.9586 25.7151 17.9033 26.2055C17.8481 26.6959 17.3757 28.5438 16.2836 28.5438C15.1915 28.5438 14.67 27.0726 14.6394 26.3012C14.6087 25.5297 14.5841 24.806 15.1486 24.806C15.713 24.806 16.0259 25.3323 16.2775 25.3323H16.2836Z",
			fill: "#72BF44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2592 11.3201C16.9504 11.3201 17.5108 9.68144 17.5108 7.66005C17.5108 5.63865 16.9504 4 16.2592 4C15.5679 4 15.0076 5.63865 15.0076 7.66005C15.0076 9.68144 15.5679 11.3201 16.2592 11.3201Z",
			fill: "#72BF44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2288 13.1381C16.2288 13.1381 13.3329 9.02352 12.9035 9.11323C12.474 9.20294 12.0752 10.1718 11.8666 11.1227C11.658 12.0736 11.3696 13.1321 11.5844 13.5507C11.7991 13.9694 15.4251 17.9643 16.2288 17.9404C17.0325 17.9165 20.0756 14.0531 20.3824 13.5268C20.7137 12.9527 20.3394 9.31656 19.6768 9.10126C18.9222 8.86204 16.2349 13.1381 16.2349 13.1381H16.2288Z",
			fill: "#72BF44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3021 19.7585C16.3021 19.7585 12.4307 15.8054 11.8663 15.8951C11.3018 15.9848 10.7619 16.9118 10.4797 17.8268C10.1975 18.7418 9.8171 19.7585 10.0993 20.1592C10.3815 20.5599 15.2223 24.3994 16.2959 24.3754C17.3696 24.3515 21.4312 20.6376 21.8361 20.1353C22.2779 19.5851 21.7809 16.0865 20.8913 15.8831C19.8851 15.6499 16.2959 19.7585 16.2959 19.7585H16.3021Z",
			fill: "#72BF44"
		})
	]
});
export default SvgSidebarMenuButton;
